export default __webpack_public_path__ + "static/media/basketball.3f609005.png";